/* tslint:disable:no-any */
import { isNil } from '../../utils';

import { Type } from '../interfaces/type.interface';

import { SerializableObject } from './serializable-object';

/**
 * Wrapper for a list of serializable objects. It MUST be used for API endpoints that return an
 * array of SerializableObject.
 */
export class SerializableObjectList<T extends SerializableObject> extends SerializableObject {
  public items: T[];
  private readonly type: Type<T>;

  constructor(type: Type<T>, json?: any) {
    super();
    this.type = type;
    // TODO: #8284 This method should not be called a 2nd time.
    this.buildFromJSON(json);
  }

  public buildFromJSON(objectValues: any): void {
    if (isNil(objectValues)) {
      return;
    }

    this.items = [];
    if (Array.isArray(objectValues)) {
      objectValues.forEach((objectValue: any): void => {
        const item: T = new this.type();
        item.buildFromJSON(objectValue);
        this.items.push(item);
      });
    }
  }
}
